import Heading from "@vfuk/core-heading";
import Spacing from "@vfuk/core-spacing";
import { t } from "i18next";

const CustomerFormHeading = () => {
  return (
    <>
      <Spacing
        spacingLevel={{
          left: 3,
        }}
      >
        <Heading level={5} weight={3}>
          {t("core:customers:heading")}
        </Heading>
        <span>{t("core:customers:required_text")} </span>
      </Spacing>
    </>
  );
};
export default CustomerFormHeading;
